import Logo from "../icons/logo.svg";
import React, { forwardRef } from "react";
import PreviewBar from "./preview-bar";
import { Link } from "./link";
import MainBenefits from "./main-benefits";
import BannerPushNotification from "./elements/banner-push-notification";
import BannerTopMenu from "./banner-top-menu";

const HeaderSimple = forwardRef(
  ({ siteTitle, hideMainBenefits, mainBenefits, bannerTop, bannerRef, customLogo }, ref) => {
    return (
      <div ref={ref} className="header">
        {process.env.EDIT_MODE === "true" && <PreviewBar />}
        {bannerTop && (
          <BannerPushNotification
            sleekNoteId="sn-785b13d4-ee9e-4fc6-acfe-e7bcc50e61dd"
            topMenu={true}
          >
            <BannerTopMenu ref={bannerRef} data={bannerTop} />
          </BannerPushNotification>
        )}
        <div className="header__top">
          <div className="container-fluid wrapper">
            <div className="row">
              <div className="col-12">
                <div className="logo text-center">
                  <Link className="logo__link" to="/" aria-label={siteTitle}>
                    {customLogo ? (
                      <img
                        alt={customLogo?.value?.description || ""}
                        className="icon-svg"
                        src={customLogo.node.publicURL}
                      />
                    ) : (
                      <Logo />
                    )}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {hideMainBenefits !== "yes" && <MainBenefits data={mainBenefits} />}
      </div>
    );
  }
);

export default HeaderSimple;
